import React from 'react'
import './Info.module.scss'
import data from './data.json'

const Info = props => (
  <div styleName="wrap">
    {/* <div styleName="xGrid"> */}
    {/* <div styleName="xCol"> */}
    {/* <div styleName="yGrid"> */}
    {/* <div styleName="yCol"> */}
    <h2 styleName="claim">
      {data.claim}
      <span>{data.subclaim}</span>
    </h2>
    {/* </div> */}
    {/* <div styleName="yCol"> */}
    <a styleName="mail" href={data.mail.link}>
      {data.mail.text}
    </a>
    {/* </div> */}
    {/* </div> */}
    {/* </div> */}
    {/* <div styleName="xCol"> */}
    {/* <div styleName="yGrid"> */}
    {/* <div styleName="yCol"> */}
    {/* <div
              styleName='bio'
              dangerouslySetInnerHTML={{ __html: data.bio }}
            /> */}
    {/* <ul styleName='services'>
              {data.services.map((service, i) => {
                return <li key={i}>{service}</li>
              })}
            </ul> */}
    {/* </div> */}
    {/* <div styleName="yCol"> */}
    {/* <div styleName="office" dangerouslySetInnerHTML={{ __html: data.office }} /> */}
    {/* <div styleName="footer">{data.footer}</div> */}
    {/* </div> */}
    {/* </div> */}
    {/* </div> */}
    {/* </div> */}
  </div>
)

export default Info



// WEBPACK FOOTER //
// ./src/components/Info/index.js